import React from "react";
import { Button as MatButton, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    border: 0,
    borderRadius: "0.1rem",
    minHeight: 50,
    fontSize: "1.1rem",
    fontFamily: "Ride",
    fontWeight: "400",
    textTransform: "none",
    padding: "5px 15px 5px 15px",
    boxShadow: "inset 0 0.2rem 0.4rem 0 rgba(0,0,0,0.1)",
    background: theme.palette.primary.main,
    color: theme.hertzColors.ninetyBlack,
    "&:hover": {
      background: theme.palette.primary.hover,
      fontWeight: "700",
    },
    "&:disabled": {
      background: theme.hertzColors.disabled,
      color: "white",
    },
  },
}));

const Button = ({ fullWidth, title, disabled, color, ...rest }) => {
  const classes = useStyles();
  let style = `${classes.root}`;
  style = `${style} ${classes[color]}`;

  return (
    <MatButton className={style} fullWidth={fullWidth} disabled={disabled} {...rest}>
      {title}
    </MatButton>
  );
};

export default Button;
